module.exports = __webpack_public_path__ + "18-o2.jpg?2bd091077586688667ce7ea293795a4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/18-o2.jpg
// module id = 635
// module chunks = 0